import { Input } from '@/app/common/components/input/Input'
import { cn } from '@/common/utilities.ts' // Adjust import based on your utility location

interface RoleControlProps {
  title: string
  description?: string
  isChecked: boolean
  onCheckedChange: (checked: boolean) => void
  className?: string
}

const RoleControl: React.FC<RoleControlProps> = ({
  title,
  description,
  isChecked,
  onCheckedChange,
  className,
}) => {
  return (
    <div className={cn('py-2 flex items-center gap-2.5', className)}>
      <Input
        type="checkbox"
        className="w-4 h-4 mr-2 text-primary hover:ring-primary focus:ring-primary"
        checked={isChecked}
        onChange={(e) => onCheckedChange(e.target.checked)}
      />
      <div className="flex flex-col gap-1">
        <span className="flex items-center gap-1.5 leading-none font-semibold text-sm text-gray-900">
          {title}
        </span>
        {description && (
          <span className="text-sm text-gray-500">{description}</span>
        )}
      </div>
    </div>
  )
}

export default RoleControl
